import type { FaireProductEntity } from "../../entity_types/product";

export const p_fe69e9w5bd: FaireProductEntity = {
  token: "p_fe69e9w5bd",
  type: "product",
  name: "Moonstone, 8-sided point",
  brandToken: "b_gy2hjqt9aj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/46f69aad71d4bf1e9c39763baf226881f393b940e989658971b2fd85285b9282.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bcfeabdb8f6d721102f216c98a0b85c40d0399c233616e7e614cec01ac283588.jpeg",
  ],
  priceDollars: 11.01,
  description:
    "8-Sided Carved Moonstone Points\n\nDiscover the subtle elegance of our 8-sided moonstone points, each hand-carved into an obelisk shape that reflects a unique charm thanks to its artisanal finish.\n\nMoonstone is prized for its iridescent flashes, reminiscent of the natural phenomenon of a rainbow. Belonging to the feldspar family, this stone may display translucent veining, as well as black markings and other natural imperfections that emphasize its authenticity.\n\nThese points are sold individually and each is approximately 8 to 10 cm tall with a thickness of about 2 cm. Due to their handmade construction, the dimensions and symmetry of each point may vary, enhancing the distinctive character of these pieces.\n\nThe photographs illustrate the quality and type of moonstone you will receive, but each piece is a unique specimen.\n\nThese handcrafted products from India not only reflect the tradition and care in their making, but also carry the beauty and magic that moonstone naturally offers.",
  tags: [],
  msrpDollars: 22.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:37.351Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
